import * as React from 'react';
import RcSteps from 'rmc-steps';
import Icon from '../icon';
export default class Steps extends React.Component {
    componentDidMount() {
        this.componentDidUpdate();
    }
    componentDidUpdate() {
        if (this.props.direction !== 'horizontal') {
            return;
        }
        // set tail's left position based on main's width for each step dynamically.
        this.stepRefs.forEach(s => {
            if (s.refs.tail) {
                s.refs.tail.style.left = `${s.refs.main.offsetWidth / 2}px`;
            }
        });
    }
    render() {
        this.stepRefs = [];
        const { children, status, size } = this.props;
        const current = this.props.current;
        // flattern the array at first https://github.com/ant-design/ant-design-mobile/issues/934
        const filterChildren = [];
        if (children && children.length) {
            children.forEach((item) => {
                if (React.isValidElement(item)) {
                    filterChildren.push(item);
                }
            });
        }
        const newChildren = React.Children.map(filterChildren, (item, index) => {
            let className = item.props.className;
            if (index < filterChildren.length - 1 &&
                filterChildren[index + 1].props.status === 'error') {
                className = className ? `${className} error-tail` : 'error-tail';
            }
            let icon = item.props.icon;
            if (!icon) {
                if (index < current) {
                    // 对应 state: finish
                    icon = 'check-circle-o';
                }
                else if (index > current) {
                    // 对应 state: wait
                    icon = 'ellipsis';
                    className = className
                        ? `${className} ellipsis-item`
                        : 'ellipsis-item';
                }
                if ((status === 'error' && index === current) ||
                    item.props.status === 'error') {
                    icon = 'cross-circle-o';
                }
            }
            icon =
                typeof icon === 'string' ? (<Icon type={icon} size={size === 'small' ? (status === 'wait' ? 'xxs' : 'xs') : 'md'}/>) : (icon);
            return React.cloneElement(item, {
                icon,
                className,
                ref: (c) => (this.stepRefs[index] = c),
            });
        });
        return (<RcSteps ref={(el) => (this.stepsRef = el)} {...this.props}>
        {newChildren}
      </RcSteps>);
    }
}
Steps.Step = RcSteps.Step;
Steps.defaultProps = {
    prefixCls: 'am-steps',
    iconPrefix: 'ant',
    labelPlacement: 'vertical',
    direction: 'vertical',
    current: 0,
};



// WEBPACK FOOTER //
// ./components/steps/index.tsx